import React, { useState, useEffect, useContext, useRef } from "react";
import GoBack from "../../components/goBack";
import Select from "react-select";
import axios from "axios";
import { API, baseURL } from "../../services/api";
import OrgContext from "../../organisation/OrgContext";
import AuthContext from "../../components/shared/AuthContext";
import $ from "jquery";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment/moment";
import { formatNumber, isNumeric } from "../../helpers/formater";
import NewClient from "../Items/NewClient";
import useAuthHelper from "../../helpers/AuthHelper";
/**
 * create new Incoice
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
function NewFactureAvoir(props) {
  const navigate = useNavigate();
  const [t, i18n] = useTranslation();
  const { organisation, changeOrg } = useContext(OrgContext);
  const { user, logout } = useContext(AuthContext);
  const [clients, setClients] = useState([]);
  const [products, setProducts] = useState([]);

  //new product to invoice state
  const [productId, setProductId] = useState();
  const [qty, setQty] = useState(0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [tva, setTva] = useState(0);
  const [totalHt, setTotalHt] = useState(0);
  const [totalTtc, setTotalTtc] = useState(0);

  const [singleSelectedProduct, setSingleSelectedProduct] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [invoiceProductsState, setInvoiceProductsState] = useState([]);
  let invoiceProducts = [];

  //useRef
  const leTotalHt = useRef(0);
  const leTotalTTc = useRef(0);

  //summary
  const [summaryTotatlHt, setSummaryTotatlHt] = useState(0);
  const [summaryTotalTva, setSummaryTotalTva] = useState(0);
  const [summaryTotatlTtc, setSummaryTotatlTtc] = useState(0);

  //edit product
  const [productIdToEdit, setProductIdToEdit] = useState(0);

  //form state
  /**
   * {
   *     "value": 92,
   *     "label": "test testchoulla"
   * }
   */
  const currentYear = new Date().getFullYear();
  const firstDayOfYear = `${currentYear}-01-01`;
  const lastDayOfYear = `${currentYear}-12-31`;
  const date_now = new Date();
  const [client, setClient] = useState([]);
  const [invoiceCreatedAt, setInvoiceCreatedAt] = useState(
    date_now ? moment(date_now).format("yyyy-MM-DD") : "",
  );
  const [invoiceDueDate, setInvoiceDueDate] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [objet, setObjet] = useState("");
  const [invoiceStatus, setInvoiceStatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  const [payedAmount, setPayedAmount] = useState(0);
  const [autoIncrementInvoiceNumber, setAutoIncrementInvoiceNumber] =
    useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [lastInvoiceNumber, setLastInvoiceNumber] = useState(0);
  const [numeroDeLaFacture, setNumeroDeLaFacture] = useState(0);
  const [selectedProductQty, setSelectedProductQty] = useState(0);

  const [banquePaymentOption, setBanquePaymentOption] = useState("");
  const [chequeId, setChequeId] = useState("");
  const [banqueAccounts, setBanqueAccounts] = useState([]);
  const [bqAccountId, setBqAccountId] = useState(0);
  const errorMessage = "Tous les champs sont obligatoire !";
  const [isSubmit, setIsSubmit] = useState(false);
  const [nbInvoices, setNbInvoices] = useState(0);
  const [invoicesNums, setInvoicesNums] = useState([]);
  const [numExist, setExitNum] = useState(false);
  const { onlyCommercial, hadAddAccess } = useAuthHelper();

  useEffect(() => {
    onlyCommercial();
    hadAddAccess();
    console.log("tchanga", invoiceProductsState);
    calcInvoiceSummary(invoiceProductsState);
    getAccounts();
  }, [invoiceProductsState]);

  const handleAutoIncrementInvoiceNumber = () => {
    if (autoIncrementInvoiceNumber === false) {
      $("#invoiceNumberInput").css("display", "none");
    } else {
      $("#invoiceNumberInput").css("display", "block");
    }
  };
  /**
   * get all associated clients
   *
   * @returns {Promise<void>}
   */
  const getAllAssociatedClients = async () => {
    const response = await axios
      .get(baseURL + `/client/getbyuser/${user.id}/client/${organisation.id}`)
      .then((response) => {
        if (response.data.data.length === 0) {
          $("#warning-create-client-first").css("display", "block");
        } else {
          $("#warning-create-client-first").css("display", "none");
          setClients(transformClientsArray(response.data.data));
          console.log("lcintes : ", clients);
          /**
           * {
           *     "value": 56,
           *     "label": "Commodi minus omnis Ipsum ullam architec"
           * }
           */
        }
      })
      .catch((error) => console.log("error " + error));
  };

  const getAccounts = async () => {
    await axios
      .get(baseURL + "/paymentAccounts")
      .then((response) => {
        setBanqueAccounts(response.data.data);
        response.data.data.map((a) => {
          if (a.name === "Banques (soldes débiteurs)") {
            setBqAccountId(a.id);
          }
        });
        console.log("banque accout: ", banqueAccounts);
      })
      .catch((error) =>
        console.log("error while retrieving setBanqueAccounts : " + error),
      );
  };

  const getAllAssociatedProducts = async () => {
    const response = await axios
      .get(baseURL + `/product/getbyuser/${user.id}/${organisation.id}`)
      .then((response) => {
        setProducts(transformProductsArray(response.data.data));
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error),
      );
  };

  const transformClientsArray = (clients) => {
    let array = [];
    for (let i = 0; i < clients.length; i++) {
      let obj = { value: clients[i].id, label: clients[i].companyName };
      array.push(obj);
    }
    return array;
  };

  const calcInvoiceSummary = (invoiceProducts) => {
    let totalHt = 0;
    let totalTva = 0;
    let totalTtc = 0;
    // {
    //     "name": "Funny Morning Sarcastic SVG, Sarcastic Morning SVG, Sarcastic SVG, Sarcasm svg, Funny Mug svg,Cut File for Cricut,Silhouette",
    //     "qty": "1",
    //     "unitPrice": 100,
    //     "tva": 20,
    //     "totalHt": "100",
    //     "totalTtc": "120"
    // },
    for (let i = 0; i < invoiceProductsState.length; i++) {
      totalHt += parseFloat(invoiceProductsState[i].totalHt);
      totalTtc += parseFloat(invoiceProductsState[i].totalTtc);
      totalTva +=
        parseFloat(invoiceProductsState[i].totalTtc) -
        parseFloat(invoiceProductsState[i].totalHt);
    }
    setSummaryTotatlHt(totalHt);
    setSummaryTotalTva(totalTva);
    setSummaryTotatlTtc(totalTtc);
  };
  const hideOffcanvas = () => {
    const offcanvasElement = document.getElementById("offcanvasBottom");

    const offcanvas =
      window.bootstrap?.Offcanvas.getInstance(offcanvasElement) ||
      new window.bootstrap.Offcanvas(offcanvasElement);

    offcanvas.hide();
  };

  const addNewProductToInvoice = async () => {
    /**
     * singleSelectedProduct ok
     * qty,unitPrice ok
     * leTotalHt.current.value : ok
     * leTotalTTc.current.value : OK
     *
     */
    if (selectedProduct.value === null || qty === 0) {
      $("#all-fields-are-required").css("display", "block");
    } else {
      hideOffcanvas();
      $("#all-fields-are-required").css("display", "none");
      if (checkIfProductAlreadyExist(singleSelectedProduct.value)) {
        $("#warning-product-already-exists").css("display", "block");
      } else {
        $("#warning-product-already-exists").css("display", "none");
        /**
         * prepare product
         * @type {{unitPrice: number, qty: number, name, totalTtc, totalHt, tva: number}}
         */
        let product = {
          product_id: singleSelectedProduct.value,
          name: singleSelectedProduct.label,
          qty: qty,
          unitPrice: unitPrice,
          tva: tva,
          totalHt: leTotalHt.current.value,
          totalTtc: leTotalTTc.current.value,
        };
        invoiceProducts.push(product);
        setInvoiceProductsState([...invoiceProductsState, product]);
      }
    }
  };

  const checkIfProductAlreadyExist = (productId) => {
    for (let i = 0; i < invoiceProductsState.length; i++) {
      if (invoiceProductsState[i].product_id === productId) {
        console.log("exist");
        return true;
      }
    }
    console.log("! exist");
    return false;
  };
  const getProductData = async (selectedProduct) => {
    //selectedProduct
    const response = await axios
      .get(baseURL + `/product/get/${selectedProduct.value}`)
      .then((response) => {
        setQty(0);
        setSelectedProductQty(response.data.data[0].qty);
        setTva(response.data.data[0]["taxe_vente"]["rate"]);
      })
      .catch((error) => console.log("error " + error));
  };
  const transformProductsArray = (products) => {
    let array = [];
    for (let i = 0; i < products.length; i++) {
      let obj = {
        value: products[i].id,
        label: products[i].name,
        unit_price: products[i].sellingPrice,
      };
      array.push(obj);
    }
    return array;
  };

  const getNbsInvoices = async () => {
    let resp = await jwtInterceoptor.get(
      `/data/nb-factures/factures-avoir/${organisation?.id}`,
    );
    if (resp.status == 200) {
      let data = resp.data;
      if (data?.status) {
        setNbInvoices(data?.nb_factures);
        setInvoicesNums(data.data);
      }
    }
  };

  useEffect(() => {
    $(".all-fields-are-required-to-save").css("display", "none");
    $("#warning-create-client-first").css("display", "none");
    $("#table-rows").css("display", "none");
    $("#all-fields-are-required").css("display", "none");
    $("#warning-product-already-exists").css("display", "none");
    $("#qty-is-higher").css("display", "none");
    getAllAssociatedClients();
    getAllAssociatedProducts();
    getInvoiceStatus();
    getIncrementedInvoiceNumber();
    getNbsInvoices();
  }, []);
  const getInvoiceStatus = async () => {
    const response = await API.get("/factures/status")
      .then((res) => {
        setInvoiceStatus(res.data.data);
      })
      .catch((error) => console.log(error));
  };
  const deleteSingleProduct = (productId) => {
    for (let i = 0; i < invoiceProductsState.length; i++) {
      if (invoiceProductsState[i].product_id === productId) {
        invoiceProductsState.splice(i, 1);
        console.log("spliced");
      }
    }
    setInvoiceProductsState([...invoiceProductsState]);
  };

  const editSingleProduct = (productId) => {
    $(".select-article").css("display", "none");
    $(".add-new-product-to-invoice-btn").css("display", "none");
    $(".edit-single-product").css("display", "revert");
    setProductIdToEdit(productId);

    let product = invoiceProductsState.filter(
      (p) => p.product_id === productId,
    );

    setQty(product[0]["qty"]);
    setUnitPrice(product[0]["unitPrice"]);
    setTva(product[0]["tva"]);
  };
  /**
   * {
   *     "product_id": 75,
   *     "name": "Funny Morning Sarcastic SVG, Sarcastic Morning SVG, Sarcastic SVG, Sarcasm svg, Funny Mug svg,Cut File for Cricut,Silhouette",
   *     "qty": "1",
   *     "unitPrice": 100,
   *     "tva": 20,
   *     "totalHt": "100",
   *     "totalTtc": "120"
   *     'product_id': singleSelectedProduct.value,
   *                 'name': singleSelectedProduct.label,
   *                 'qty': qty,
   *                 'unitPrice': unitPrice,
   *                 'tva': tva,
   *                 'totalHt': leTotalHt.current.value,
   *                 'totalTtc': leTotalTTc.current.value
   * }
   */
  const editSingleInvoiceProduct = () => {
    if (selectedProduct.value === null || qty === 0) {
      $("#all-fields-are-required").css("display", "block");
    } else {
      $("#all-fields-are-required").css("display", "none");
      hideOffcanvas();
      for (let i = 0; i < invoiceProductsState.length; i++) {
        if (invoiceProductsState[i].product_id === productIdToEdit) {
          invoiceProductsState[i].qty = qty;
          invoiceProductsState[i].totalHt = leTotalHt.current.value;
          invoiceProductsState[i].totalTtc = leTotalTTc.current.value;
        }
        setInvoiceProductsState([...invoiceProductsState]);
      }
    }
  };

  const changeOfCanvasLayouts = () => {
    $("#all-fields-are-required").css("display", "none");
    $(".select-article").css("display", "block");
    $(".add-new-product-to-invoice-btn").css("display", "inline");
    $(".edit-single-product").css("display", "none");
    emptyInputs();
  };
  const emptyInputs = () => {
    setSingleSelectedProduct([]);
    setQty(0);
    setUnitPrice(0);
  };
  const getIncrementedInvoiceNumber = async () => {
    let value = 0;
    const response = await jwtInterceoptor
      .get("/data/user/facturesavoir/last/" + organisation.id)
      .then((res) => {
        console.log("getIncrementedInvoiceNumber: ", res.data.data.id);
        if (res.data.data !== null) {
          setNumeroDeLaFacture(res.data.data.id + 1);
        } else {
          setNumeroDeLaFacture(1);
        }
      })
      .catch((error) => console.log("error while save", error));
  };

  const save = () => {
    if (
      numExist ||
      client.value === undefined ||
      invoiceDueDate.length === 0 ||
      invoiceCreatedAt.length === 0 ||
      invoiceProductsState.length === 0 ||
      objet.length === 0 ||
      selectedStatus === 0 ||
      (autoIncrementInvoiceNumber === false && invoiceNumber === "")
    ) {
      toast.error("Tous les champs sont obligatoire !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      // $(".all-fields-are-required-to-save").css('display', 'none');
      let numeroDeFacture = "";
      /**
       * {
       *     "product_id": 75,
       *     "name": "Funny Morning Sarcastic SVG, Sarcastic Morning SVG, Sarcastic SVG, Sarcasm svg, Funny Mug svg,Cut File for Cricut,Silhouette",
       *     "qty": "1",
       *     "unitPrice": 100,
       *     "tva": 20,
       *     "totalHt": "100",
       *     "totalTtc": "120"
       * }
       * @type {*[]}
       */
      let preparedProducts = [];
      let is_custom_invoice_number = 0;
      let incrementedValue = 0;
      if (autoIncrementInvoiceNumber === false) {
        is_custom_invoice_number = 1;
        numeroDeFacture = isNumeric(invoiceNumber)
          ? `FACT-AVOIR-${formatNumber(invoiceNumber)}`
          : `FACT-AVOIR-${invoiceNumber}`;
      } else {
        numeroDeFacture = `FACT-AVOIR-${nbInvoices + 1}`;
      }

      for (let i = 0; i < invoiceProductsState.length; i++) {
        const ref = Math.random().toString(36).substring(2, 7);
        let obj = {
          product_id: invoiceProductsState[i].product_id,
          price_unit_ht: invoiceProductsState[i].unitPrice,
          qty: invoiceProductsState[i].qty,
          total_ht: invoiceProductsState[i].totalHt,
          total_ttc: invoiceProductsState[i].totalTtc,
          tva: invoiceProductsState[i].tva,
          reference: ref,
        };
        preparedProducts.push(obj);
      }

      const prepareObject = {
        user_id: user.id,
        organisation_id: organisation.id,
        client_id: client.value,
        total_ht: summaryTotatlHt,
        total_ttc: summaryTotatlTtc,
        total_tva: summaryTotalTva,
        title: objet,
        due_date: invoiceDueDate,
        created_at_date: invoiceCreatedAt,
        status: selectedStatus,
        payed_amount: payedAmount,
        products: preparedProducts,
        invoice_number: numeroDeFacture,
        is_custom_invoice_number: is_custom_invoice_number,
        payment_method: paymentType,
        payment_account: paymentType,
        banquePaymentOption: banquePaymentOption,
        chequeId: chequeId,
      };
      saveInvoice(prepareObject);
    }
  };

  /**  BA9I DEVIS **/

  const saveInvoice = async (invoice) => {
    setIsSubmit(true);
    const response = await jwtInterceoptor
      .post("/data/user/factures_avoir/add", invoice)
      .then((res) => {
        setIsSubmit(false);
        Swal.fire(t("La facture est créer avec succès"), t(""), "success");
        navigate("/sales/factureavoir/list");
      })
      .catch((error) => {
        setIsSubmit(false);
        console.log("error while save", error);
      });
  };

  const onSaveClient = () => {
    getAllAssociatedClients();
    window.$("#newClientModal").modal("hide");
    console.log("has been saved");
    Swal.fire(t("Le client a été ajouter avec succès"), t(""), "success");
  };

  return (
    <>
      <ToastContainer />

      <div className="main-container container-fluid">
        <GoBack route="/sales/factureavoir/list" />

        <div className="page-header">
          <h1 className="page-title breadcumpsHeader">Facture d'avoir</h1>
          <div>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a
                  href="javascript:void(0)"
                  onClick={() => navigate("/sales/factureavoir/list")}
                >
                  Liste des facture d'avoir
                </a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Ajouter une facture d'avoir
              </li>
            </ol>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <div
                class="alert alert-danger alert-dismissible fade show mb-0 all-fields-are-required-to-save"
                role="alert"
              >
                <span class="alert-inner--icon">
                  <i class="fe fe-slash"></i>
                </span>
                <span class="alert-inner--text">
                  <strong></strong> Tous les champs sont obligatoire !
                </span>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <br />
              <div
                class="modal fade"
                id="newClientModal"
                tabIndex="-1"
                aria-labelledby="newClientModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h1 class="modal-title fs-5" id="newClientModal">
                        Ajouter un nouveaux client
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <NewClient
                        clientType={"client"}
                        from={"new_fv"}
                        handleSave={onSaveClient}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <h4>{t("Espace client")}</h4>
              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      Nom du client*
                    </label>
                    <Select
                      options={clients}
                      onChange={(choice) => setClient(choice)}
                    />
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      Nouveau Client
                    </label>
                    <a
                      className="btn btn-primary form-control"
                      data-bs-toggle="modal"
                      data-bs-target="#newClientModal"
                    >
                      <i className="fe fe-user"></i> ajouter un client
                    </a>
                  </div>
                </div>
              </div>
              <hr className={"custom-hr"} />
              <h4>Informations sur la facture</h4>
              <hr className={"custom-hr"} />
              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      N° de la facture * (
                      {t(
                        "ce numéro servira de référence pour votre facture originale",
                      )}
                      )
                    </label>
                    <input
                      type="text"
                      placeholder="Fac-0001"
                      className={`form-control `}
                      onChange={(e) => {
                        setInvoiceNumber(e.target.value);
                        let numExist = invoicesNums.findIndex(
                          (c) =>
                            e.target.value == c?.invoice_number ||
                            e.target.value ==
                              (c.is_custom_invoice_number == 1
                                ? c.invoice_number
                                : `Fact-avoir-${formatNumber(c?.invoice_number)}`),
                        );
                        if (numExist != -1) {
                          setExitNum(true);
                        } else {
                          setExitNum(false);
                        }
                      }}
                      value={invoiceNumber}
                      id={"invoiceNumberInput"}
                    />
                    {!autoIncrementInvoiceNumber && numExist ? (
                      <span className={"text-danger"}>
                        {t("Ce numéro de facture existe déjà")}
                      </span>
                    ) : null}
                    <label className="custom-control custom-checkbox-md">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        name="example-checkbox5"
                        value="option5"
                        checked={autoIncrementInvoiceNumber}
                        onClick={() =>
                          setAutoIncrementInvoiceNumber(
                            !autoIncrementInvoiceNumber,
                          )
                        }
                        onChange={(e) => {
                          handleAutoIncrementInvoiceNumber();
                        }}
                      />
                      <span class="custom-control-label">
                        Utiliser le numéro de facture auto-incrementer
                      </span>
                    </label>
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      Objet*
                    </label>
                    <input
                      type="text"
                      placeholder="objet"
                      className={`form-control `}
                      onChange={(e) => setObjet(e.target.value)}
                      value={objet}
                    />
                  </div>
                </div>
              </div>
              <hr className={"custom-hr"} />
              <h5>Les dates</h5>
              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      date de facture*
                    </label>
                    <input
                      type="date"
                      placeholder="nom"
                      className={`form-control `}
                      onChange={(e) => setInvoiceCreatedAt(e.target.value)}
                      value={invoiceCreatedAt}
                      //min={firstDayOfYear}
                      //max={lastDayOfYear}
                    />
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      date d'échéance*
                    </label>
                    <input
                      type="date"
                      placeholder="nom"
                      className={`form-control `}
                      onChange={(e) => setInvoiceDueDate(e.target.value)}
                      value={invoiceDueDate}
                      min={firstDayOfYear}
                    />
                  </div>
                </div>
              </div>
              <hr className={"custom-hr"} />
              <h5>
                {t("Produits")}/{t("Services")}
              </h5>
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">DÉTAILS DE L’ARTICLE</th>
                    <th scope="col">QUANTITÉ</th>
                    <th scope="col">PU HT</th>
                    <th scope="col">TVA %</th>
                    <th scope="col">Total HT</th>
                    <th scope="col">Total TTC</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                {invoiceProductsState.map((product) => {
                  /**
                   * [
                   *     {
                   *         "name": "Funny Morning Sarcastic SVG, Sarcastic Morning SVG, Sarcastic SVG, Sarcasm svg, Funny Mug svg,Cut File for Cricut,Silhouette",
                   *         "qty": "1",
                   *         "unitPrice": 100,
                   *         "tva": 20,
                   *         "totalHt": "100",
                   *         "totalTtc": "120"
                   *     },
                   *     {
                   *         "name": "Butterfly Anklet, Charm Anklet, Diamond Butterfly Anklet, Gold Butterfly Anklet, Simple Butterfly Anklet, Gift for Women, Gift for Her",
                   *         "qty": "2",
                   *         "unitPrice": 199,
                   *         "tva": 20,
                   *         "totalHt": "398",
                   *         "totalTtc": "477.6"
                   *     }
                   * ]
                   */
                  return (
                    <tr key={product.product_id}>
                      <td>{product.name}</td>
                      <td>{product.qty}</td>
                      <td>{product.unitPrice}</td>
                      <td>{product.tva + "%"}</td>
                      <td>{product.totalHt}</td>
                      <td>{product.totalTtc}</td>
                      <td>
                        <i
                          onClick={() =>
                            deleteSingleProduct(product.product_id)
                          }
                          class="fe fe-trash"
                        ></i>
                      </td>
                      <td>
                        <i
                          data-bs-toggle="offcanvas"
                          aria-controls="offcanvasBottom"
                          data-bs-target="#offcanvasBottom"
                          onClick={() => editSingleProduct(product.product_id)}
                          class="fe fe-edit"
                        ></i>
                      </td>
                    </tr>
                  );
                })}
              </table>
              <center>
                <button
                  onClick={changeOfCanvasLayouts}
                  className="btn btn-primary off-canvas btn-sm mb-1"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasBottom"
                  aria-controls="offcanvasBottom"
                >
                  <i className="fe fe-plus"></i>
                  ajouter un article
                </button>
              </center>
              <hr className={"custom-hr"} />
              <div className={"row"}>
                <div className={"col-md-6"}></div>
                <div className={"col-md-6 d-flex flex-row-reverse"}>
                  <div className="row">
                    <div className="invoiceSummary">
                      <table>
                        <tr>
                          <td className={"invoiceSummary-base"}>Total HT :</td>
                          <td>
                            {Number(summaryTotatlHt).toFixed(2)}{" "}
                            {organisation?.currency?.code}
                          </td>
                        </tr>
                        <tr>
                          <td className={"invoiceSummary-base"}>Total TVA :</td>
                          <td>
                            {Number(summaryTotalTva).toFixed(2)}{" "}
                            {organisation?.currency?.code}
                          </td>
                        </tr>
                        <tr>
                          <td className={"invoiceSummary-base"}>Total TTC :</td>
                          <td>
                            {Number(summaryTotatlTtc).toFixed(2)}{" "}
                            {organisation?.currency?.code}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      Etat*
                    </label>
                    <select
                      className="form-select"
                      id="buyPriceAccountInput"
                      onChange={(e) => setSelectedStatus(e.target.value)}
                      value={selectedStatus}
                    >
                      <option value="0">
                        sélectionner l'état de la facture
                      </option>
                      {invoiceStatus.map((status) => {
                        return <option value={status.id}>{status.name}</option>;
                      })}
                    </select>
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div
                    className="paymentSection"
                    style={{
                      display:
                        selectedStatus === "2" || selectedStatus === "3"
                          ? "block"
                          : "none",
                    }}
                  >
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1" className="">
                        Banque ou Caisse*
                      </label>
                      <select
                        className="form-select"
                        id="buyPriceAccountInput"
                        onChange={(e) => {
                          setPaymentType(e.target.value);
                          console.log("paymùslkdnb;s,:", e.target.value);
                        }}
                        value={paymentType}
                      >
                        <option value="0">
                          selectionner un mode de réglement
                        </option>
                        {banqueAccounts.map((account) => (
                          <option
                            value={account.id}
                            onClick={() => console.log("ffdfdfd")}
                          >
                            {account.code + " - " + account.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="banqueOptions">
                      <div
                        className="verementOrChéque"
                        style={{
                          display:
                            paymentType === "" + bqAccountId + ""
                              ? "block"
                              : "none",
                        }}
                      >
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            Mode de Réglement *
                          </label>
                          <select
                            className="form-select"
                            id="buyPriceAccountInput"
                            onChange={(e) =>
                              setBanquePaymentOption(e.target.value)
                            }
                            value={banquePaymentOption}
                          >
                            <option value="0">
                              selectionner un mode de réglement
                            </option>
                            <option value="virement">Virement</option>
                            <option value="chéque">Chéque</option>
                          </select>
                        </div>
                      </div>
                      <div
                        className="libelleIfcheque"
                        style={{
                          display:
                            banquePaymentOption === "chéque" &&
                            paymentType === "" + bqAccountId + ""
                              ? "block"
                              : "none",
                        }}
                      >
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            Identificateur du chéque*
                          </label>
                          <input
                            type="text"
                            placeholder=""
                            className={`form-control `}
                            onChange={(e) => setChequeId(e.target.value)}
                            value={chequeId}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="form-group"
                      style={{
                        display: selectedStatus === "3" ? "block" : "none",
                      }}
                    >
                      <label htmlFor="exampleInputEmail1" className="">
                        Montant payé
                      </label>
                      <input
                        type="text"
                        placeholder="objet"
                        className={`form-control `}
                        onChange={(e) => setPayedAmount(e.target.value)}
                        value={payedAmount}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <br />
              <div class="card-footer">
                <div className="d-flex flex-row-reverse">
                  <button
                    disabled={isSubmit}
                    type="button"
                    className="btn btn-primary "
                    onClick={save}
                  >
                    {isSubmit ? t("Loading ...") : t("Enregistrer")}
                  </button>
                  <a
                    onClick={() => {
                      navigate(-1);
                    }}
                    className="btn btn-default"
                    style={{ marginRight: 10 }}
                  >
                    Annuler
                  </a>
                </div>
              </div>

              <div
                class="offcanvas offcanvas-bottom addProductCanvas"
                tabIndex="-1"
                id="offcanvasBottom"
                aria-labelledby="offcanvasBottomLabel"
              >
                <div class="offcanvas-header">
                  <h5 class="offcanvas-title" id="offcanvasBottomLabel">
                    Remplir le produit a ajouter
                  </h5>
                  <button
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  >
                    <i class="fe fe-x fs-18"></i>
                  </button>
                </div>
                <div class="offcanvas-body">
                  <div id="all-fields-are-required">
                    <div
                      class="alert alert-danger alert-dismissible fade show mb-0"
                      role="alert"
                    >
                      <span class="alert-inner--icon">
                        <i class="fe fe-slash"></i>
                      </span>
                      <span class="alert-inner--text">
                        <strong>Attention!</strong> Tous les champs sont
                        obligatoire !
                      </span>
                    </div>
                    <br />
                  </div>

                  <div id="warning-product-already-exists">
                    <div
                      class="alert alert-danger alert-dismissible fade show mb-0"
                      role="alert"
                    >
                      <span class="alert-inner--icon">
                        <i class="fe fe-slash"></i>
                      </span>
                      <span class="alert-inner--text">
                        <strong>Attention!</strong> Le produit déja exist !
                      </span>
                    </div>
                    <br />
                  </div>

                  <div id="qty-is-higher">
                    <div
                      class="alert alert-danger alert-dismissible fade show mb-0"
                      role="alert"
                    >
                      <span class="alert-inner--icon">
                        <i class="fe fe-slash"></i>
                      </span>
                      <span class="alert-inner--text">
                        <strong>Attention!</strong> L'article choisie est en
                        rupture de stock
                      </span>
                    </div>
                    <br />
                  </div>

                  <form className="needs-validation" noValidate="">
                    <div class="form-row">
                      <div class="col-xl-12 mb-3">
                        <label
                          className={"select-article"}
                          htmlFor="validationTooltip01"
                        >
                          DÉTAILS DE L’ARTICLE*
                        </label>
                        <Select
                          value={singleSelectedProduct}
                          className={"select-article"}
                          options={products}
                          onChange={(choice) => {
                            setUnitPrice(choice.unit_price);
                            setQty(0);
                            setSingleSelectedProduct(choice);
                            getProductData(choice);
                            console.log("chihaja", choice);
                            //console.log("tva: ",singleSelectedProduct.taxevente)
                            //setTvaForProduct(singleSelectedProduct.taxevente)
                          }}
                        />
                      </div>
                      <div class="col-xl-3 mb-3">
                        <label htmlFor="validationTooltip02">QUANTITÉ*</label>
                        <input
                          type="text"
                          className="form-control"
                          id="validationTooltip02"
                          required=""
                          value={qty}
                          onChange={(e) => {
                            console.log("unitPrice:", unitPrice);
                            console.log(
                              "selectedProductQty:",
                              selectedProductQty,
                            );

                            if (e.target.value > selectedProductQty) {
                              $("#qty-is-higher").css("display", "block");
                            } else {
                              $("#qty-is-higher").css("display", "none");
                              setQty(e.target.value);
                              setTotalHt(parseInt(qty) * parseInt(unitPrice));
                            }
                            //setTotalTtc((unitPrice + ((unitPrice * tva) / 100)) * qty);
                          }}
                        />
                      </div>
                      <div class="col-xl-3 mb-3">
                        <label htmlFor="validationTooltip02">PU HT*</label>
                        <input
                          type="number"
                          className="form-control"
                          id="validationTooltip02"
                          required=""
                          value={unitPrice}
                          onChange={(e) => setUnitPrice(unitPrice)}
                          disabled={true}
                        />
                      </div>
                      <div class="col-xl-3 mb-3">
                        <label htmlFor="validationTooltip02">Total HT*</label>
                        <input
                          type="text"
                          className="form-control"
                          id="validationTooltip02"
                          required=""
                          value={qty * unitPrice}
                          ref={leTotalHt}
                        />
                      </div>
                      <div class="col-xl-3 mb-3">
                        <label htmlFor="validationTooltip02">Total TTC*</label>
                        <input
                          type="number"
                          className="form-control"
                          id="validationTooltip02"
                          required=""
                          value={(unitPrice + (unitPrice * tva) / 100) * qty}
                          ref={leTotalTTc}
                        />
                      </div>
                    </div>
                    <i
                      className="fe fe-plus btn btn-primary add-new-product-to-invoice-btn"
                      onClick={addNewProductToInvoice}
                    ></i>
                    <i
                      className="fe fe-edit btn btn-primary edit-single-product"
                      onClick={editSingleInvoiceProduct}
                    ></i>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewFactureAvoir;
